// extracted by mini-css-extract-plugin
module.exports = {"title":"SupportingLinks_title__kpvdR","link_list_item":"SupportingLinks_link_list_item__aRfOr","link":"SupportingLinks_link__h9SbM","non_link":"SupportingLinks_non_link__lX3cQ"};